import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

// Layouts
import AdminLayout from '../layouts/AdminLayout';
import StudentLayout from '../layouts/StudentLayout';

// Admin Pages
import LoginPage from '../pages/admin/LoginPage';
import AdminRegisterPage from '../pages/admin/AdminRegisterPage';
import DashboardPage from '../pages/admin/DashboardPage';
import DrivesPage from '../pages/admin/DrivesPage';
import DriveDetailsPage from '../pages/admin/DriveDetailsPage';
import AssessmentBuilderPage from '../pages/admin/AssessmentBuilderPage';
import QuestionBankPage from '../pages/admin/QuestionBankPage';
import ShareLinkPage from '../pages/admin/ShareLinkPage';
import RegisteredStudentsPage from '../pages/admin/RegisteredStudentsPage';
import ResultsDrivesPage from '../pages/admin/ResultsDrivesPage';
import ResultsPage from '../pages/admin/ResultsPage';
import StudentResultPage from '../pages/admin/StudentResultPage';

// Student Pages
import RegistrationPage from '../pages/student/RegistrationPage';
import InstructionsPage from '../pages/student/InstructionsPage';
import AssessmentPage from '../pages/student/AssessmentPage';
import SubmittedPage from '../pages/student/SubmittedPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Root redirect */}
      <Route path="/" element={<Navigate to="/admin/login" replace />} />

      {/* Admin Routes - Unprotected */}
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin/register" element={<AdminRegisterPage />} />

      {/* Admin Routes - Protected */}
      <Route path="/admin" element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="drives" element={<DrivesPage />} />
          <Route path="drives/:driveId" element={<DriveDetailsPage />} />
          <Route path="drives/:driveId/assessment" element={<AssessmentBuilderPage />} />
          <Route path="drives/:driveId/share" element={<ShareLinkPage />} />
          <Route path="drives/:driveId/students" element={<RegisteredStudentsPage />} />
          <Route path="results" element={<ResultsDrivesPage />} />
          <Route path="drives/:driveId/results" element={<ResultsPage />} />
          <Route path="drives/:driveId/results/:attemptId" element={<StudentResultPage />} />
          <Route path="question-bank" element={<QuestionBankPage />} />
        </Route>
      </Route>

      {/* Student Routes */}
      <Route path="/register/:token" element={<RegistrationPage />} />
      <Route path="/assess/:token" element={<StudentLayout />}>
        <Route index element={<InstructionsPage />} />
        <Route path="instructions" element={<InstructionsPage />} />
        <Route path="test" element={<AssessmentPage />} />
        <Route path="submitted" element={<SubmittedPage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
